import React, { useEffect, useState } from "react";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

const PrintPreviewReamBundleConvertionRpt = ({ parentRollDetails, cono }) => {
    const [parentRoll, setParentRoll] = useState([]);


    useEffect(() => {
        if (parentRollDetails) {
            setParentRoll(parentRollDetails);
        }

    }, [parentRollDetails]);

    // Function to format the date to 'dd-mm-yyyy'
    const formatDate = (date) => {
        if (!date) return ''; // Return empty string if no date is provided
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0'); // Pad day with leading zero if needed
        const month = String(d.getMonth() + 1).padStart(2, '0'); // Months are 0-based, so add 1
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };

    const exportPDF = () => {
        const pdf = new jsPDF('l', 'mm', 'a4');
        const margin = 5;
        let currentY = margin;
        const pageWidth = pdf.internal.pageSize.getWidth();
        const tableWidth = 50; // Adjust table width as needed

        // Title
        pdf.setFontSize(18);
        currentY += 4;
        pdf.text('Cutting to Finishing', margin, currentY);
        currentY += 5;

        // ADD LINE
        pdf.setLineWidth(0.2); // Set the thickness of the line (optional)
        pdf.line(margin, currentY, pdf.internal.pageSize.getWidth() - margin, currentY); // Draw line across the page
        currentY += 5; // Adjust space after the line

        // MO Report Header
        pdf.setFontSize(10);
        pdf.text(`PO NO : ${cono ? cono : 'N/A'} .`, margin, currentY);
        currentY += 5;

        pdf.text(`QUALITY : ${parentRollDetails[0]?.item_code} .`, margin, currentY); currentY += 5;

        pdf.text(`gsm : ${parentRollDetails[0]?.gsm} .`, margin, currentY); currentY += 5;

        pdf.text(`size : ${parentRollDetails[0]?.width} X ${parentRollDetails[0]?.length}`, margin, currentY); currentY += 5;
        currentY += 5;
        pdf.text(`No of Sheets : ${parentRollDetails[0]?.no_of_sheets_indent} .`, margin, currentY); currentY += 5;

        // ADD LINE
        pdf.setLineWidth(0.2); // Set the thickness of the line (optional)
        pdf.line(margin, currentY, pdf.internal.pageSize.getWidth() - margin, currentY); // Draw line across the page
        currentY += 10; // Adjust space after the line



        pdf.setFontSize(10);



        // Check if `parentRoll` exists and is an array
        const body = parentRoll && Array.isArray(parentRoll) ? parentRoll.map((detail) => [
            detail.id,
            detail.pr_number,
            detail.child_reel_number
        ]) : []; // Fallback to empty array if `parentRoll` is undefined

        // Table for MO Details
        if (body.length > 0) {
            autoTable(pdf, {
                startY: currentY,
                head: [['SR NO', 'ROLL NO', 'REEL NO.', 'F.NO REAM', 'REAM TOTAL', 'BUNDLE TOTAL', 'REMARK', 'LOCATION']],
                body: body,
                theme: 'grid',
                styles: { fontSize: 6, fontFamily: 'cambria' },
                headStyles: { fillColor: [61, 73, 162], halign: 'center' },
                margin: { left: margin, right: margin },
            });

            currentY = pdf.previousAutoTable.finalY + 10;
        } else {
            pdf.text('No parent roll details available.', margin, currentY);
            currentY += 10;
        }



        currentY = pdf.previousAutoTable?.finalY + 5 || currentY;


        // Save the PDF
        pdf.save(`Reel pending convertion Report.pdf`);
    };


    // 
    const printdata = () => {
        const margin = '10px';
        let pageStyles = `
    <style>
        body { font-family: Cambria, serif; margin: 10px; padding: 10px; }
        h1 { font-size: 20px; margin: 5px 0; text-align: left; }
        h2 { font-size: 16px; margin: 10px 0; }
        p { font-size: 15px; margin: 3px 0; }
        table { width: 100%; border-collapse: collapse; margin: 0px 0; font-size: 18px; }
        th, td { border: 1px solid #000; padding: 5px; text-align: left; }
        th { background-color: rgb(253, 253, 253); color: black; text-align: center; }
        .line { border-bottom: 1px solid #000; margin: 0px 0; }

        .header-grid {
            display: flex;
            justify-content: space-between;
            align-items: stretch;
            gap: 0px;
            font-size: 12px;
        }
         .col-1, .col-2, .col-3 {
        padding: 10px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }
        
    .col-1 {
        width: 20%;
        border-left: 1px solid #000;
        border-right: 1px solid #000;
        display: flex;
        flex-direction: column;
        justify-content: flex-start; /* align items to top instead of stretching */
        padding: 10px;
    }

    .col-2 {
        width: 50%;
        border-right: 1px solid #000;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 10px;
    }

    .col-3 {
        width: 30%;
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: bold;
        font-size: 24px;
        text-align: center;
        border-right: 1px solid #000;
    }

    .col-1 p, .col-2 p {
        margin: 2px 0; /* tighter spacing */
        font-size: 16px;
    }

     
      .label { font-weight: normal; }
    .value { font-weight: bold; }

    .row {
        display: flex;
      justify-content: center; /* center horizontally */
    align-items: center;     /* center vertically */
        gap: 20px;
    }

    .rownew {
    display: flex;
    justify-content: left;
    align-items: left;
    border-right: 1px solid #000;
    border-left: 1px solid #000;
   
    
}
.rownew p {
    margin-right: 60px;
    margin-bottom: 0;
    margin-top: 0;
      margin-left: 10px;
}




    </style>
    `;

        let content = `
        ${pageStyles}
    <div class="line"></div>
            <!-- New Row with Extra Details -->
    <div class="rownew" style="padding: 10px 0; font-size: 14px;">
        <p><span class="label"  style="margin-right: 80px;">MACHINE NO:</span> <span class="value"></span></p>
        <p><span class="label" style="margin-right: 90px;">OPERATOR NAME:</span> <span class="value"></span></p>
        <p><span class="label">REAM WEIGHT: ${parentRollDetails[0]?.ream_weight}</span> <span class="value"></span></p>
        <p><span class="label">REAMS IN BUNDLE: ${parentRollDetails[0]?.reams_in_bundle}</span> <span class="value"></span></p>
        <p><span class="label">LOCATION:</span> <span class="value"></span></p>
    </div>
       
    <div class="line"></div>

    <div class="header-grid">
    
        <div class="col-1">
            <p style="margin-top:12px">Date: ${new Date().toLocaleDateString('en-GB')}</p>
            <p>Planning No:  ${parentRollDetails[0]?.planning_no || 'N/A'}</p>
        </div>

        <div class="col-2">
            <div class="row">
                <p>PO No: <b>${cono || 'N/A'}</b> , </p>
                <p>Quality:<b> ${parentRollDetails[0]?.item_code || 'N/A'}</b> , </p>
                <p>GSM: <b>${parentRollDetails[0]?.gsm || 'N/A'} , </b></p>
                <p>No of Sheets:<b> ${parentRollDetails[0]?.no_of_sheets_indent || 'N/A'},</b></p>
            </div>
            <div class="row">
              
                <p>Size: <b> ${parentRollDetails[0]?.width} X ${parentRollDetails[0]?.length}</b> , </p>
                <p>Package Mode:<b> ${parentRollDetails[0]?.package_mode || 'N/A'}</b>,</p> 
                
            </div>
            <div class="row">
                <p>Rewinder Qty (Kgs):<b> ${(parentRoll.reduce((acc, cur) => acc + (parseFloat(cur.achieved_qty) || 0), 0) * 1000).toFixed(1)}</b> , </p>
                <p>Planning Qty (Kgs):<b> ${(parentRollDetails[0]?.planned_qty * 1000).toFixed(1)}</b> , </p>
 <p>Order Qty (kgs):<b> ${(parentRollDetails[0]?.order_qty)}</b></p>
            </div>
        </div>

        <div class="col-3">
            FG REPORT
        </div>
    </div>

    
        
    `;

        // Check if `parentRoll` exists and is an array
        if (parentRoll && Array.isArray(parentRoll) && parentRoll.length > 0) {

            let totalAchievedQty = 0; // initialize total

            content += `
        <table>
            <thead>
                <tr>
                    <th>SR NO</th>
                    <th>ROLL NO</th>
                    <th>REEL NO.</th>
                    <th>REEL WT.</th>                 
                    <th style="width: 10px;">CLAC. SHEET</th>
                    <th>REWINDER REMARKS</th>                            
                    <th style="width: 50px;">ACTUAL SHEETS</th>
                    <th style="width: 50px;">NO OF PALLET</th>
                    <th style="width: 50px;">F. NO</th>
                    <th style="width: 100px;">ACTUAL REAM</th>
                    <th style="width: 50px;">TOTAL REAM</th>
                    <th style="width: 200px;">REMARKS</th>
                </tr>
            </thead>
            <tbody>
    `;

            parentRoll.forEach(detail => {
                const achievedQty = parseFloat(detail.achieved_qty) || 0;
                totalAchievedQty += achievedQty;

                content += `
            <tr>                  
                <td>${detail.id || 'N/A'}</td>
                <td>${detail.pr_number}</td>
                <td>${detail.child_reel_number}</td>
                <td style="text-align: right;">${(achievedQty * 1000).toFixed(1)}</td>
                <td style="text-align: right;width:10px">${detail.no_of_sheets || '0'}</td>
                <td>${detail.rewinder_remarks || ''}</td>
                <td  style="width: 50px;"></td>
                <td style="width: 50px;"></td>
                <td style="width: 50px;"></td>
                <td style="width: 100px;"></td>
                <td style="width: 50px;"></td>
                <td style="width: 200px;"></td>
            </tr>
        `;
            });

            // Append total row
            content += `
        <tr style="font-weight: bold;">
            <td colspan="3" style="text-align: right;">Total Reel Weight (Kgs)</td>
            <td  style="text-align: right;">${(totalAchievedQty * 1000).toFixed(1)}</td>
            <td colspan="10"></td>
        </tr>
    `;

            content += `
            </tbody>
        </table>
    `;

        } else {
            content += `<p>No parent roll details available.</p>`;
        }


        // Open a new window and print
        const printWindow = window.open('', '_blank');
        printWindow.document.write(content);
        printWindow.document.close();
        printWindow.print();
    };

    return (
        <div style={{ padding: '10pt', fontFamily: 'cambria', fontSize: '12px', color: 'black', backgroundColor: 'white' }}>
            <h1>  FG REPORT
                <div style={{ marginRight: 'auto' }}>

                    <button onClick={printdata} >Print Preview</button>
                </div>
            </h1>
            <hr />
            {/* onClick={exportPDF} */}

            <div id="report" style={{ padding: '1px', backgroundColor: '#fff', color: '#000' }}>
                <div>
                    <div
                        id="report"
                        style={{
                            padding: '0px',
                            backgroundColor: '#fff',
                            color: '#000',
                            marginBottom: '10px',
                        }}
                    >
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between', // Adjust spacing evenly
                                alignItems: 'center', // Align vertically
                                flexWrap: 'wrap', // Wrap content if necessary
                            }}
                        >
                            <p style={{ margin: '0 10px' }}>
                                Date: {new Date().toLocaleDateString('en-GB')} {/* Format: DD/MM/YYYY */}
                            </p>
                            <p style={{ margin: '0 10px' }}>
                                Planning No : {parentRollDetails[0]?.planning_no}
                            </p>
                            <p style={{ margin: '0 10px' }}>
                                PO NO : {`${cono ? cono : ''}`}
                            </p>
                            <p style={{ margin: '0 10px' }}>
                                QUALITY : {parentRollDetails[0]?.item_code}
                            </p>
                            <p style={{ margin: '0 10px' }}>
                                GSM : {parentRollDetails[0]?.gsm}
                            </p>

                            <p style={{ margin: '0 10px' }}>
                                Size: {parentRollDetails[0]?.width} x {parentRollDetails[0]?.length}
                            </p>

                            <p style={{ margin: '0 10px' }}>
                                Package Mode : {parentRollDetails[0]?.package_mode}
                            </p>
                            <p style={{ margin: '0 10px' }}>
                                No of Sheets : {parentRollDetails[0]?.no_of_sheets_indent}
                            </p>

                            <p style={{ margin: '0 10px', fontWeight: 'bold' }}>
                                FG REPORT
                            </p>
                        </div>

                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'left', // Adjust spacing evenly
                                alignItems: 'left', // Align vertically
                                flexWrap: 'wrap', // Wrap content if necessary
                            }}
                        >


                            <p style={{ margin: '0 10px' }}>
                                Rewinder Qty (Kgs): {(parentRoll.reduce((acc, cur) => acc + (parseFloat(cur.achieved_qty) || 0), 0) * 1000).toFixed(1)}
                            </p>
                            <p style={{ margin: '0 50px' }}>
                                {/* Planning Qty (Kgs): { (parentRoll.reduce((acc, cur) => acc + (parseFloat(cur.planned_qty) || 0), 0) * 1000).toFixed(1)} */}

                                Planning Qty (kgs): {(parentRollDetails[0]?.planned_qty * 1000).toFixed(1)}
                            </p>
                            <p style={{ margin: '0 10px' }}>
                                Order Qty (kgs): {(parentRollDetails[0]?.order_qty)}
                            </p>
                            <p style={{ margin: '0 10px' }}>

                            </p>
                            <p style={{ margin: '0 10px' }}>

                            </p>


                        </div>

                    </div>
                </div>

                {parentRoll.length > 0 && (
                    <>

                        <div style={{ marginBottom: '20px', pageBreakAfter: 'always' }}>

                            <div style={{ width: '100%' }}>

                                <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '0px' }}>
                                    <thead>
                                        <tr>
                                            <th style={{ border: '0.2px groove black', padding: '2px', width: '130px' }}>SR NO</th>
                                            <th style={{ border: '0.2px groove black', padding: '2px', width: '80px' }}>ROLL NO</th>
                                            <th style={{ border: '0.2px groove black', padding: '2px', width: '70px' }}>REEL NO.</th>
                                            <th style={{ border: '0.2px groove black', padding: '2px', width: '150px' }}>REEL WT.</th>
                                            <th style={{ border: '0.2px groove black', padding: '2px', width: '100px' }}>CLAC.SHEET</th>
                                            <th style={{ border: '0.2px groove black', padding: '2px', width: '100px' }}>REWINDER REMARK</th>
                                            <th style={{ border: '0.2px groove black', padding: '5px', width: '60px' }}>ACTUAL SHEETS</th>
                                            <th style={{ border: '0.2px groove black', padding: '2px', width: '60px' }}>NO OF PALLET</th>
                                            <th style={{ border: '0.2px groove black', padding: '2px', width: '60px' }}>F. NO</th>
                                            <th style={{ border: '0.2px groove black', padding: '2px', width: '60px' }}>ACTUAL REAM</th>
                                            <th style={{ border: '0.2px groove black', padding: '2px', width: '60px' }}>TOTAL REAM</th>
                                            <th style={{ border: '0.2px groove black', padding: '2px', width: '60px' }}>REMARKS</th>
                                        </tr>
                                    </thead>
                                    {parentRoll.map((mo, index) => (
                                        <tbody key={index}>

                                            <tr>

                                                <td style={{ border: '0.2px groove black', padding: '5px', textAlign: 'center' }}> {mo.id} </td>
                                                <td style={{ border: '0.2px groove black', padding: '5px', textAlign: 'center' }}>{mo.pr_number}</td>
                                                <td style={{ border: '0.2px groove black', padding: '5px', textAlign: 'center' }}>{mo.child_reel_number}</td>
                                                <td style={{ border: '0.2px groove black', padding: '5px', textAlign: 'center' }}> {(mo.achieved_qty * 1000).toFixed(1)}</td>


                                                <td style={{ border: '0.2px groove black', padding: '5px', textAlign: 'center' }}> {mo.no_of_sheets}</td>

                                                <td style={{ border: '0.2px groove black', padding: '5px', textAlign: 'center' }}>{mo.rewinder_remarks}</td>
                                                <td style={{ border: '0.2px groove black', padding: '5px', textAlign: 'center' }}></td>
                                                <td style={{ border: '0.2px groove black', padding: '5px', textAlign: 'center' }}></td>
                                                <td style={{ border: '0.2px groove black', padding: '5px', textAlign: 'center' }}> </td>
                                                <td style={{ border: '0.2px groove black', padding: '5px', textAlign: 'center' }}> </td>
                                                <td style={{ border: '0.2px groove black', padding: '5px', textAlign: 'center' }}> </td>
                                                <td style={{ border: '0.2px groove black', padding: '5px', textAlign: 'center' }}> </td>

                                            </tr>
                                        </tbody>
                                    ))}
                                </table>
                            </div>
                        </div>

                    </>
                )}





            </div>

        </div>
    );
}
export default PrintPreviewReamBundleConvertionRpt;